import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Live Threadworth: one event bus. Any mutation (api interceptor) or bulk-import tick calls bumpWorth();
 *  every subscriber (nav chip, closet header, dashboard) refetches /stats and animates to the new number. */
const EVENT = "threadlist:worth";
let timer = null;
export const bumpWorth = () => {
  clearTimeout(timer);
  timer = setTimeout(() => window.dispatchEvent(new Event(EVENT)), 400);
};

// api.js fires the raw event (it can't import this file without a cycle); debounce it here.
if (typeof window !== "undefined") window.addEventListener("threadlist:worth:raw", bumpWorth);

export const useLiveStats = (pollMs = 30000) => {
  const [stats, setStats] = useState(null);
  const load = useCallback(() => api.getStats().then(setStats).catch(() => {}), []);
  useEffect(() => {
    load();
    const onBump = () => load();
    window.addEventListener(EVENT, onBump);
    const t = pollMs ? setInterval(load, pollMs) : null;
    return () => { window.removeEventListener(EVENT, onBump); if (t) clearInterval(t); };
  }, [load, pollMs]);
  return stats;
};
